
// import { } from "@ant-design/icons-vue";
import myFooter from "@/views/layout/footer.vue";
import { defineComponent, toRefs, ref, reactive } from "vue";
import useWrapper from "./useScoreSearch";
import { scopePublishApi } from "@/api/common";
// import { useRoute } from "vue-router";
export default defineComponent({
  name: "",
  components: {
    myFooter,
  },
  setup() {
    //*********** definning variables start **********//
    const { rawData, scopeSearch } = useWrapper();
    const ruleForm = ref<HTMLElement | null>(null);
    let tableData = reactive({
      tableData: [],
    });
    //*********** definning variables end **********//
    //*********** initData start **********//
    getScopePublish();
    //*********** initData end **********//
    //*********** format start **********//
    //*********** format end **********//
    //*********** Data FUN start **********//
    //*********** Data FUN end **********//
    //*********** DOM FUN start **********//

    function handleSearch(ruleForm: any) {
      ruleForm.validate((valid: any) => {
        if (valid) {
          scopeSearch();
        } else {
          return false;
        }
      });
    }

    function getScopePublish() {
      scopePublishApi({ Keywords: "", PageIndex: 1, PageSize: 3000 }).then(
        (res: any) => {
          tableData.tableData = res.contents;
        }
      );
    }
    //*********** DOM FUN end **********//
    return {
      ...toRefs(rawData),
      handleSearch,
      ruleForm,
      ...toRefs(tableData),
    };
  },
});
